import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getKedoToken } from './kedoApi';

const KedoAuthGuard = ({ children }) => {
    const location = useLocation();
    if (!getKedoToken()) {
        return (
            <Navigate
                to="/kedo/login"
                replace
                state={{ from: location.pathname }}
            />
        );
    }
    return children;
};

export default KedoAuthGuard;
